<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/hello' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据显示配置</el-breadcrumb-item>
      <el-breadcrumb-item>数据显示配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:15px;">
      <el-form
        ref="queryForm"
        :model="userSearchData"
        size="small"
        :inline="true"
        label-width="68px"
      >
      <el-form-item label="统计类型">
          <el-select
            v-model="userSearchData.type"
            clearable
            style="width: 150px">
            <el-option label="总计统计" value="0"/>
            <el-option label="游戏统计" value="1"/>
          </el-select>
      </el-form-item>
      <el-form-item label="方案名" prop="group_id">
          <el-select placeholder="请选择方案名"  v-model="userSearchData.group_id">
                <el-option
                  v-for="item in groups"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
        </el-form-item> 
        <el-form-item label="显示状态" prop="status">
          <el-select
            v-model="userSearchData.status"
            clearable
            style="width: 150px"
          >
            <el-option label="显示" value="1" />
            <el-option label="不显示" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="userSearchData.time"
            style="width: 220px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="searchDataInfo()"
            >搜索</el-button>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-plus"
            @click="addversion"
            >新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table v-loading="pageloading" border :data="versionListData" stripe style="width: 100%">
        <el-table-column prop="Id" label="序列号" width="80"></el-table-column>
        <el-table-column prop="user_id" label="用户ID" width="80"></el-table-column>
        <el-table-column prop="name" label="列显示名" width="100"></el-table-column>
        <el-table-column prop="tb_item_name" label="列名" width="160">
          <template slot-scope="scope">
            {{getColumnName(scope.row.tb_item_name)}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="显示状态" width="100">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 0">不显示</el-tag>
            <el-tag type="success" v-if="scope.row.status == 1">显示</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180">
          <template slot-scope="scope">
            {{changeDateFormat(scope.row.create_time)}}
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间"  width="180">
          <template slot-scope="scope">
            {{changeDateFormat(scope.row.update_time)}}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="450" fixed="right">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="upSort(scope.row)">
              <img src="../../../static/upsort.png" alt="向上移动" style="width: 16px; height: 16px; vertical-align: middle;">
              向上移动
            </el-button>
            <el-button type="warning" size="mini" @click="downSort(scope.row)">
              <img src="../../../static/downsort.png" alt="向下移动" style="width: 16px; height: 16px; vertical-align: middle;">
              向下移动
            </el-button>
            <el-button type="success" size="mini" @click="edit(scope.row)"
              >编辑</el-button>
            <el-button type="danger" size="mini" @click="deleteDataInfo(scope.row)"
                >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
      <!-- 分页功能 -->
    </el-card>

    <!-- 添加版本弹框 -->
    <el-dialog v-loading="editpageloading" title="新增信息" :visible.sync="addVisible" width="50%">
      <el-form
        :model="addruleForm"
        ref="addruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="统计类型" prop="type">
          <el-radio-group v-model="editruleForm.type">
            <el-radio label="0">总计统计</el-radio>
            <el-radio label="1">游戏统计</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="列显示名" prop="name">
          <el-input v-model="addruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="显示类型" prop="column_type">
          <el-radio-group v-model="addruleForm.column_type">
            <el-radio label="0">基本信息</el-radio>
            <el-radio label="1">游戏信息</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="基本信息列名" width="160" v-if="showTotalDataSelect">
            <el-select placeholder="请选择基本信息列名"  v-model="addruleForm.tb_item_name"  @change="updateName">
                <el-option
                  v-for="item in tablecolumns"
                  :key="item.column_name"
                  :label="item.column_comment"
                  :value="item.column_name">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="游戏信息列名" width="160"  v-if="showGameDataSelect">
            <el-select placeholder="请选择游戏信息列名"  v-model="addruleForm.tb_item_name"  @change="updateName">
                <el-option
                  v-for="item in gametablecolumns"
                  :key="item.column_name"
                  :label="item.column_comment"
                  :value="item.column_name">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="方案名" prop="tb_item_name">
          <el-select placeholder="请选择方案名"  v-model="addruleForm.group_id">
                <el-option
                  v-for="item in groups"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
        </el-form-item> 
        <el-form-item label="显示状态" prop="status">
          <el-radio-group v-model="addruleForm.status">
            <el-radio label="0">不显示</el-radio>
            <el-radio label="1">显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="addruleForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="数据类型" prop="data_type">
          <el-radio-group v-model="addruleForm.data_type">
            <el-radio label="0">整型</el-radio>
            <el-radio label="1">浮点型</el-radio>
            <el-radio label="2">百分比</el-radio>
            <el-radio label="3">字符串</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addsubmitForm('addruleForm')"
            >添加内容</el-button
          >
          <el-button @click="addresetForm('addruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加版本弹框 -->

    <!-- 编辑版本弹框 -->
    <el-dialog  v-loading="editpageloading" title="编辑信息" :visible.sync="editVisible" width="50%">
      <el-form
        :model="editruleForm"
        ref="editruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="统计类型" prop="type">
          <el-radio-group v-model="editruleForm.type">
            <el-radio :label="0">总计统计</el-radio>
            <el-radio :label="1">游戏统计</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="名称" prop="name" :readonly="true">
          <el-input v-model="editruleForm.name"></el-input>
        </el-form-item>
        <el-table-column prop="tb_item_name" label="列名" width="160">
          <template slot-scope="scope">
            {{
              getColumnName(scope.row.tb_item_name)
            }}
          </template>
        </el-table-column>
        <el-form-item label="显示类型" prop="column_type">
          <el-radio-group v-model="editruleForm.column_type">
            <el-radio label="0">基本信息</el-radio>
            <el-radio label="1">游戏信息</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="列名" width="160" v-if="showTotalDataSelect">
            <el-select placeholder="请选择列名"  v-model="editruleForm.tb_item_name"  @change="updateName">
                <el-option
                  v-for="item in tablecolumns"
                  :key="item.column_name"
                  :label="item.column_comment"
                  :value="item.column_name">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="列名" width="160"  v-if="showGameDataSelect">
            <el-select placeholder="请选择列名"  v-model="editruleForm.tb_item_name"  @change="updateName">
                <el-option
                  v-for="item in gametablecolumns"
                  :key="item.column_name"
                  :label="item.column_comment"
                  :value="item.column_name">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="方案名" prop="tb_item_name" :readonly="true">
          <el-select placeholder="请选择方案名"  v-model="editruleForm.group_id">
                <el-option
                  v-for="item in groups"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
        </el-form-item> 
        <el-form-item label="显示状态" prop="status">
          <el-radio-group v-model="editruleForm.status">
            <el-radio :label="0">不显示</el-radio>
            <el-radio :label="1">显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="editruleForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="数据类型" prop="data_type">
          <el-radio-group v-model="editruleForm.data_type">
            <el-radio :label="0">整型</el-radio>
            <el-radio :label="1">浮点型</el-radio>
            <el-radio :label="2">百分比</el-radio>
            <el-radio :label="3">字符串</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editsubmitForm('editruleForm')"
            >提交修改</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑弹框 -->
  </div>
</template>

<script>
// import { changeDateFormat } from "@/utils/util";
import { getcurrentTime } from "@/utils/public";
import { isString, getCookie } from '../../utils/util';
export default {
  data() {
    return {
      showTotalDataSelect: false,
      showGameDataSelect: false,
      pageloading: false,
      editpageloading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0, //请求列表的总条数
      userSearchData: {
        type: 0,
        status: -1,
        group_id: 0,
        time: ""
      },
      // 添加版本信息数据
      addruleForm: {
        user_id: "",
        name: "数据总计表",
        tb_name: "yx_data_sum",
        tb_item_name: "",
        tb_game_item_name: "",
        status: 0,
        column_type: 0,
        sort: 0,
        group_id: 0,
        data_type: 0
      },
      // 修改版本信息数据
      editruleForm: {
        id: "",
        user_id: "",
        name: "数据总计表",
        tb_name: "yx_data_sum",
        tb_item_name: "",
        status: 0,
        column_type: 0,
        sort: 0,
        group_id: 0,
        data_type: 0
      },
      tablecolumns: [
        {
          column_name: "",
          column_comment: "",
        }
      ],
      gametablecolumns: [
        {
          column_name: "",
          column_comment: "",
        }
      ],
      groups: [
        {
          id: "",
          name: "",
        }
      ],
      tableData: [],
      versionListData: [],
      addVisible: false,
      editVisible: false
    };
  },

  mounted() {
    this.searchAllColumnsData();
    this.searchAllGourpData();
    this.searchDataInfo();
  },

  watch: {
    'userSearchData.type': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.userSearchData.type == 0) {
          this.addruleForm.name = "总计统计";
          this.addruleForm.tb_name = "yx_data_sum";
          this.editruleForm.name = "总计统计";
          this.editruleForm.tb_name = "yx_data_sum";
        } else if (this.userSearchData.type == 1) {
          this.addruleForm.name = "游戏统计";
          this.addruleForm.tb_name = "yx_data_game";
          this.editruleForm.name = "游戏统计";
          this.editruleForm.tb_name = "yx_data_game";
        }
        this.searchAllColumnsData();
        this.searchAllGourpData();
      }
    },
    'addruleForm.type': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.searchAllColumnsData();
        this.searchAllGourpData();
        this.userSearchData.type = this.editruleForm.type;
      }
    },
    'editruleForm.type': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.searchAllColumnsData();
        this.searchAllGourpData();
        this.userSearchData.type = this.editruleForm.type;
      }
    },
    'addruleForm.column_type': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.addruleForm.column_type == 0) {
          this.showTotalDataSelect = true;
          this.showGameDataSelect = false;
          this.searchAllColumnsData();
        } else if (this.addruleForm.column_type == 1) {
          this.showGameDataSelect = true;
          this.showTotalDataSelect = false;
          this.searchAllGameColumnsData();
        }
      }
    },
    'editruleForm.column_type': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.editruleForm.column_type == 0) {
          this.showTotalDataSelect = true;
          this.showGameDataSelect = false;
          this.searchAllColumnsData();
        } else if (this.editruleForm.column_type == 1) {
          this.showGameDataSelect = true;
          this.showTotalDataSelect = false;
          this.searchAllGameColumnsData();
        }
      }
    }    
  },

  methods: {
    changeDateFormat(time, format = 'YYYY-MM-DD hh:mm:ss') {
      if(!time) return '';
      var datetime = new Date(time);
      var o = {
          'Y+': datetime.getFullYear(),
          "M+": datetime.getMonth() + 1,
          "D+": datetime.getDate(),
          "h+": datetime.getHours(),
          "m+": datetime.getMinutes(),
          "s+": datetime.getSeconds(),
          "q+": Math.floor((datetime.getMonth() + 3) / 3),
          "S": datetime.getMilliseconds()
      };
      if (/(Y+)/.test(format)) format = format.replace(RegExp.$1, (datetime.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
              format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
          }
      }
      return format;
    },
    async searchAllColumnsData() {
      this.$axios
      .post("/3699BIApi/DataSum/SelectAllColoumn",{
        type: Number.parseInt(this.userSearchData.type),
        pageSize: 50
      })
      .then(res => {
          if (res.data.code == 200) {
              var array = res.data.list;
              var resultData = [];
              for(var i = 0; i < array.length; i++) {
                  let itemObject = array[i];
                  var ob = new Object();
                  for(var k in itemObject) {
                      ob[k] = itemObject[k];
                  }
                  resultData.push(ob);
              }
              this.tablecolumns = resultData;
          }         
      });
    },
    async searchAllGameColumnsData() {
      this.$axios
      .post("/3699BIApi/DataSum/SelectAllColoumn",{
        type: Number.parseInt(2),
        pageSize: 50
      })
      .then(res => {
          if (res.data.code == 200) {
              var array = res.data.list;
              var resultData = [];
              for(var i = 0; i < array.length; i++) {
                  let itemObject = array[i];
                  var ob = new Object();
                  for(var k in itemObject) {
                      ob[k] = itemObject[k];
                  }
                  resultData.push(ob);
              }
              this.gametablecolumns = resultData;
          }         
      });
    },
    getColumnName(item) {
      var string = ``;
      if (isString(item)) {
        for(var i=0; i<this.tablecolumns.length; i++) {
          var itemObject = this.tablecolumns[i];
          if (itemObject.column_name == item) {
            string = itemObject.column_comment;
            break;
          }
        }
      }      
      return string;
    },
    async searchAllGourpData() {
      var user_id = getCookie('user_id');
      this.$axios
      .post("/3699BIApi/AdminDataSumShowGroupConfig/SearchData",{
          user_id: Number.parseInt(user_id),
          type: Number.parseInt(this.userSearchData.type),
          currentPage: 1,
          pageSize: 100
      })
      .then(res => {
        if (res.data.code == 200) {
          var array = res.data.list;
          var resultData = [];
          var fob = new Object();
          fob["id"] = "";
          fob["name"] = "不选择";
          resultData.push(fob);
          for(var i = 0; i < array.length; i++) {
            let itemObject = array[i];
            var ob = new Object();
            for(var k in itemObject) {
                ob[k] = itemObject[k];
            }
            resultData.push(ob);
          }
          this.groups = resultData;
        }
      });
    },
    // 添加用户弹框
    addversion() {
      this.addVisible = true;
    },
    updateName() {
      const selectedColumn = this.tablecolumns.find(item => item.column_name === this.addruleForm.tb_item_name);
      if (selectedColumn) {
        this.addruleForm.name = selectedColumn.column_comment;
      }
    },
    // 添加用户按钮
    addsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let time = getcurrentTime();
          this.addruleForm.create_time = time;
          console.log(this.addruleForm);
          //添加版本
          this.addVersionData(this.addruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置添加用户
    addresetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 点击编辑行内容并更改数据
    edit(data) {
      this.editVisible = true;
      for(var k in data) {
        this.editruleForm[k] = data[k];
      }
      this.editruleForm.id = Number.parseInt(data.Id);
    },
    editsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editVisible = false;
          this.updateDataInfo(this.editruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editresetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 编辑version
    async updateDataInfo(requestObject) {
      var user_id = getCookie('user_id');
      this.$axios
        .post("/3699BIApi/AdminDataSumShowConfig/UpdateData",{
            id: requestObject.id,
            user_id: Number.parseInt(user_id),
            name: requestObject.name,
            tb_name: requestObject.tb_name,
            tb_item_name: requestObject.tb_item_name,
            status: Number.parseInt(requestObject.status),
            sort: Number.parseInt(requestObject.sort),
            data_type: Number.parseInt(requestObject.data_type),
            group_id: Number.parseInt(requestObject.group_id)
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          if (res.data.code == "200") {
            this.$message.success("编辑成功");
            this.searchDataInfo();
          } else {
            this.$message.error("编辑失败");
          }
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.searchData(this.userSearchData);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.searchData(this.userSearchData);
    },
    async addVersionData(requestObject) {
      var user_id = getCookie('user_id');
      this.editpageloading = true;
      this.$axios
      .post("/3699BIApi/AdminDataSumShowConfig/AddData",{
          user_id: Number.parseInt(user_id),
          name: requestObject.name,
          tb_name: requestObject.tb_name,
          tb_item_name: requestObject.tb_item_name,
          status: Number.parseInt(requestObject.status),
          sort: Number.parseInt(requestObject.sort),
          data_type: Number.parseInt(requestObject.data_type),
          group_id: Number.parseInt(requestObject.group_id)
      })
      .then(res => {
        this.editpageloading = false;
        if (res.data.code == "200") {
          this.addVisible = false;
          this.searchDataInfo();
          this.$message('添加成功！');
        }
        else {
          console.log(res.data.message);
          this.$message.error(`添加失败:${res.data.message}`);
        }
      });
    },
    async searchData(requestObject) {
      var user_id = getCookie('user_id');
      this.$axios
      .post("/3699BIApi/AdminDataSumShowConfig/SearchData",{
          user_id: Number.parseInt(user_id),
          group_id: Number.parseInt(requestObject.group_id),
          status: Number.parseInt(requestObject.status),
          create_time: requestObject.time[0],
          update_time: requestObject.time[1],
          currentPage: this.currentPage,
          pageSize: this.pageSize
      })
      .then(res => {
          this.pageloading = false;
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.updateCurrpageData();
      });
    },
    searchDataInfo() {
      this.pageloading = true;
      this.searchData(this.userSearchData);
    },
    updateCurrpageData() {
      var arrays = [];
      var i = 0;
      var endi = this.total - (this.currentPage-1) * this.pageSize;
      if (endi > this.pageSize) {
        endi = this.pageSize;
      }
      console.log(`updateCurrpageData ${endi} 条`);
      for(; i<endi; i++) {
        if (i < this.total) {
          var itemObject = this.tableData[i];
          arrays.push(itemObject);
        }
      }
      
      this.versionListData = arrays.filter(val => {
        return val;
      });
    },
    async deleteDataInfo(data) {
      this.deleteData(data);
    },  
    // 删除
    async deleteData(data) {
      try {
        let msg = await this.$confirm("确认删除吗?");
        if (msg =  `confirm`) {
          this.deleteDataApi(data);
        }
      } catch (error) {
        return console.log("出错了：" + error);
      }
    },
    // 删除
    async deleteDataApi(data) {
      this.editpageloading = true;
      this.$axios
        .post("/3699BIApi/AdminDataSumShowConfig/DeleteData",{
          id: Number.parseInt(data.Id)
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          this.pageloading = false;
          if (res.data.code == "200") {
            this.$message.success("删除成功");
            this.searchDataInfo();
          } else {
            this.$message.error("删除失败");
          }
        },
        (error)=>{
          this.editpageloading = false;
          this.$message('请求报错：' + error);
        });
    },
    // 向上移动
    async upSort(data) {
      var user_id = getCookie('user_id');
      this.editpageloading = true;
      this.$axios
        .post("/3699BIApi/AdminDataSumShowConfig/SortData",{
          id: Number.parseInt(data.Id),
          user_id: Number.parseInt(user_id),
          sort: 7
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          this.pageloading = false;
          if (res.data.code == "200") {
            this.searchDataInfo();
          } else {
            this.$message.error("移动失败");
          }
        },
        (error)=>{
          this.editpageloading = false;
          this.$message('请求报错：' + error);
        });
    },
    // 向下移动
    async downSort(data) {
      var user_id = getCookie('user_id');
      this.editpageloading = true;
      this.$axios
        .post("/3699BIApi/AdminDataSumShowConfig/SortData",{
          id: Number.parseInt(data.Id),
          user_id: Number.parseInt(user_id),
          sort: 8
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          this.pageloading = false;
          if (res.data.code == "200") {
            this.searchDataInfo();
          } else {
            this.$message.error("移动失败");
          }
        },
        (error)=>{
          this.editpageloading = false;
          this.$message('请求报错：' + error);
        });
    },
  }
};
</script>

<style lang="sass" scoped>
</style>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         


// WEBPACK FOOTER //
// src/views/ShowConfig/AdminDataSumShowConfig.vue